var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileSessions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#314256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.512 20.716c0-3.138-4.596-5.716-10.256-5.716S5 17.578 5 20.716c0 2.298 2.578 4.428 6.389 5.269l.224.056.112 4.259 3.811-3.923h.112c5.437-.112 9.864-2.634 9.864-5.66z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M12 16.837C12 13.084 17.497 10 24.267 10s12.267 3.084 12.267 6.837c0 2.749-3.084 5.296-7.642 6.301l-.268.067-.134 5.095-4.558-4.692h-.134C17.296 23.474 12 20.458 12 16.838z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v28a3 3 0 003 3h28a3 3 0 003-3V6a3 3 0 00-3-3H6zm0-3h28a6 6 0 016 6v28a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6z"
  }))));
}

export default SvgProfileSessions;